import { useGetAccountUsage } from 'Features/accountSettings/api/getAccountUsage'
import { useGetPlansDetails } from 'Features/accountSettings/api/getPlansDetails'
import { differenceInDays } from 'date-fns'
import React, { useEffect } from 'react'
import { getProductName } from 'Utils/productName'
import { useAppStore } from 'Stores/appStoreModuleFed'
import { useUserStore } from 'Stores/userStoreModuleFed'
import { TOASTS } from 'Components/Elements/Toaster/Toast.models'
import { Link } from 'react-router-dom'
import { useHideBannersSplit } from 'Hooks/useHideBannersSplit'
import { useFrontEndEventTrackingService } from '@clickcease/cc-client-components-lib'
import {
  COOKIES,
  DAYS_IN_MONTH,
  EVENT_PROPERTIES,
  ABOUT_TO_REACH_PERCENTAGE,
  REACHED_PERCENTAGE,
  wasBannerClosed,
  setBannerCloseCookie,
} from './helpers'
import { ProductTypes } from 'Types/ProductTypes'

let wasMessageShown = false

export const useOverageUsageMessage = () => {
  const { track } = useFrontEndEventTrackingService()
  const { showSystemMessage } = useAppStore()
  const { isAdmin } = useUserStore()
  const { data: accountUsage } = useGetAccountUsage()
  const { data: planDetails } = useGetPlansDetails()
  const { shouldHideBanners } = useHideBannersSplit()

  const sendCloseEventAndSaveCookie = (usePercentage: number, platform: ProductTypes) => {
    const statusParamName = usePercentage >= REACHED_PERCENTAGE ? 'REACHED' : 'ABOUT_TO_REACH'
    const statusValue = COOKIES[statusParamName]
    const propertyName = `${platform.toUpperCase()}_${statusParamName}`

    setBannerCloseCookie(statusValue, platform)

    if (!isAdmin) {
      track(['segment', 'segment-group'], EVENT_PROPERTIES.NAME, {
        [EVENT_PROPERTIES[propertyName]]: wasBannerClosed(statusValue, platform),
      })
    }
  }

  useEffect(() => {
    if (
      !accountUsage ||
      !planDetails ||
      wasMessageShown ||
      shouldHideBanners ||
      planDetails.noCreditCard
    )
      return

    const isMoreThenOneMonthPassed =
      differenceInDays(new Date(), new Date(planDetails?.startDate)) > DAYS_IN_MONTH

    if (isMoreThenOneMonthPassed) {
      accountUsage?.forEach((packageUsage) => {
        const { usePercentage, product } = packageUsage
        let i18nKey = ''

        if (
          usePercentage >= ABOUT_TO_REACH_PERCENTAGE &&
          usePercentage < REACHED_PERCENTAGE &&
          !wasBannerClosed(COOKIES.ABOUT_TO_REACH, product)
        )
          i18nKey = 'system_messages.limit_about_to_reach'
        else if (usePercentage >= REACHED_PERCENTAGE && !wasBannerClosed(COOKIES.REACHED, product))
          i18nKey = 'system_messages.limit_reached'

        if (i18nKey.length) {
          wasMessageShown = true
          showSystemMessage(
            {
              i18nKey,
              values: {
                percent: `${usePercentage.toFixed(0)}`,
                platform: getProductName(product),
              },
              components: { goto: <Link to="/modify-plan" /> },
            },
            usePercentage >= REACHED_PERCENTAGE ? TOASTS.failure : TOASTS.warning,
            () => sendCloseEventAndSaveCookie(usePercentage, product)
          )
        }
      })
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountUsage, planDetails, shouldHideBanners])
}
